import template from './calendarInline.html';
import controller from './calendarInline.controller';
import './calendarInline.scss';

let calendarInlineComponent = {
  restrict: 'E',
  bindings: {
    date: '<',
    events: '<',
    id: '<'
  },
  template,
  controller
};

export default calendarInlineComponent;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/components/calendarInlineComponent/calendarInline/calendarInline.component.js